export default "assets/images/icons/linkedin-bd72be5c.svg";